<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BdBtn',
})
</script>
<template>
  <Button v-bind="$attrs">
    <template #icon v-if="icon">
      <component :is="icon" />
    </template>
    <slot />
  </Button>
</template>

<script lang="ts" setup name="BdBtn">
import { Button } from 'ant-design-vue'
defineProps<{
  icon?: any
}>()
</script>
